import { Product } from 'generated/graphql';
import { ProductHelper } from 'helpers/ProductHelper';
import { useEffect, useState } from 'react';
import useUser from 'stores/useCustomer';
import { ProductTypes } from 'types/ProductTypes';

type UseProductSettingsParameters = {
    changeUrlOnVariantSelect?: boolean;
};

export function useProduct(product: Product, settings?: UseProductSettingsParameters) {
    const {
        changeUrlOnVariantSelect = false,
    } = settings || {};

    const [selectedProductId, setSelectedProductId] = useState(product.id);

    const selectedProductVariant = ProductHelper.getSelectedProduct(product, selectedProductId) ?? product;
    const isProductWrapper = product.type === ProductTypes.WRAPPER;
    const isProductSimple = product.type === ProductTypes.SIMPLE;
    const isProductBundle = product.type === ProductTypes.BUNDLE;
    const isWrapperProductSelected = selectedProductVariant.type === ProductTypes.WRAPPER;
    const isSimpleProductSelected = selectedProductVariant.type === ProductTypes.SIMPLE;
    const isChildProductSelected = isProductWrapper && !isWrapperProductSelected;
    const isProductActive = selectedProductVariant.publish;
    const isAddedToCart = useUser((state) => {
        const items = state.cart?.cart?.items ?? [];

        return items.some((item) => item.product_id === selectedProductId || item?.child_id === selectedProductId);
    });
    const quantityInCart = useUser((state) => {
        const items = state.cart?.cart?.items ?? [];

        const matchedItem = items.find((item) => item.product_id === selectedProductId || item.child_id === selectedProductId);

        return matchedItem?.quantity ?? null;
    });

    useEffect(() => {
        // Set the current route to the selected variants slug
        // Only replace the last part of the current path (After splitting on /)
        // WIth the last part of the productVariant slug (after splutting on /)
        if (changeUrlOnVariantSelect && isChildProductSelected && selectedProductVariant.slug) {
            const currentPath = window.location.pathname.split('/');
            const productVariantSlug = selectedProductVariant.slug.split('/');
            currentPath[currentPath.length - 1] = productVariantSlug[productVariantSlug.length - 1];
            window.history.replaceState({}, '', currentPath.join('/'));
        }
    }, [changeUrlOnVariantSelect, isChildProductSelected, selectedProductVariant.slug]);

    return {
        isProductActive,
        isProductWrapper,
        isProductSimple,
        isProductBundle,
        isWrapperProductSelected,
        isSimpleProductSelected,
        isAddedToCart,
        selectedProductId,
        selectedProductVariant,
        isChildProductSelected,
        quantityInCart,
        setSelectedProductId,
    };
}
